import type * as uiLib from '@compliance.ai/web-components';

export const EITL_LABELS_COUNT_PER_REQUEST = 20;

export const EITL_LABELS_NO_LABELS_OPTION: uiLib.SelectOption = {
  label: 'No labels',
  value: null,
  isPinned: true
};
